import { createUseStyles } from "react-jss";

export const attachImagesStyle = createUseStyles((theme: any) => ({
    container: {
        width: "100%",
        maxWidth: "30vw",
        overflowY: "auto",
    },
}));
